// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"eb9a6f35","693":"5b26923b","845":"a5203091","983":"566af609"}[chunkId] + ".chunk.js";
};